module.exports = __webpack_public_path__ + "static/media/Icon ionic-ios-people.0c91ed6a.svg";